import axios from 'axios'
import getHeaders from '../helpers/headers'
import { getError } from 'api/helpers'
import config from '../../constants/endpoints.js'

const getHeader = () => axios({
  method: 'get',
  url: config.endpoints.smartChat.header,
  headers: getHeaders(true)
})

const deploy = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.deploy,
  data,
  headers: getHeaders(true)
}).catch(error => {
  throw getError(error)
})

const setDefault = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.setDefault,
  data,
  headers: getHeaders(true)
})

const setEarlierVersion = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.earlierVersion,
  data,
  headers: getHeaders(true)
})

const getProcessesList = (headerId) => axios({
  method: 'get',
  url: config.endpoints.smartChat.processesList.replace(':headerId', headerId),
  headers: getHeaders(true)
})

/**
 * Get partial processes list
 * @param {string} headerId
 * @param {object} [data]
 * @param {["assistant"|"conversational"|"transactional"]} [data.processType]
 *
 * @returns Promise<[object]>
 */
const getProcessesPartialList = (headerId, data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.processesPartialList.replace(':headerId', headerId || ''),
  headers: getHeaders(true),
  data: data || {}
})

const process = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.processes,
  data,
  headers: getHeaders(true)
}).catch(error => {
  throw getError(error)
})

const getProcessDetail = (processId) => axios({
  method: 'get',
  url: config.endpoints.smartChat.processesById.replace(':processId', processId),
  headers: getHeaders(true)
})

const deleteProcess = (processId) => axios({
  method: 'delete',
  url: config.endpoints.smartChat.processesById.replace(':processId', processId),
  headers: getHeaders(true)
})

const processPartialUpdate = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.processPartialUpdate,
  data,
  headers: getHeaders(true)
})

const copyProcess = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.copyTo,
  data,
  headers: getHeaders(true)
})

const getGroupsList = () => axios({
  method: 'get',
  url: config.endpoints.smartChat.groupsList,
  headers: getHeaders(true)
})

const addGroup = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.groupsNew,
  data,
  headers: getHeaders(true)
})

const editNameGroup = (data) => axios({
  method: 'put',
  url: config.endpoints.smartChat.groupsEditName,
  data,
  headers: getHeaders(true)
})

const getMessageGroup = () => axios({
  method: 'get',
  url: config.endpoints.smartChat.getMessageGroup,
  headers: getHeaders(true)
})

const deleteGroup = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.deleteGroup,
  data: data,
  headers: getHeaders(true)
})

const groupOrder = (data) => axios({
  method: 'put',
  url: config.endpoints.smartChat.groupOrder,
  data: data,
  headers: getHeaders(true)
})

const addMessage = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.messageNew,
  data,
  headers: getHeaders(true)
})

const deleteMessage = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.messageDelete,
  data,
  headers: getHeaders(true)
})

const messageOrder = (data) => axios({
  method: 'put',
  url: config.endpoints.smartChat.messageOrder,
  data,
  headers: getHeaders(true)
})

const createProcessCategory = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.processCategories,
  data,
  headers: getHeaders(true)
})

const getProcessCategoriesList = () => axios({
  method: 'get',
  url: config.endpoints.smartChat.processCategories,
  headers: getHeaders(true)
})

const updateProcessCategory = (categoryId, data) => axios({
  method: 'put',
  url: config.endpoints.smartChat.processCategory.replace(':categoryId', categoryId),
  data,
  headers: getHeaders(true)
})

const deleteProcessCategory = (categoryId) => axios({
  method: 'delete',
  url: config.endpoints.smartChat.processCategory.replace(':categoryId', categoryId),
  headers: getHeaders(true)
})

const createLabel = (data) => axios({
  method: 'post',
  url: config.endpoints.smartChat.labels,
  data,
  headers: getHeaders(true)
})

const getLabelsList = () => axios({
  method: 'get',
  url: config.endpoints.smartChat.labels,
  headers: getHeaders(true)
})

const updateLabel = (labelId, data) => axios({
  method: 'put',
  url: config.endpoints.smartChat.label.replace(':labelId', labelId),
  data,
  headers: getHeaders(true)
})

const deleteLabel = (labelId) => axios({
  method: 'delete',
  url: config.endpoints.smartChat.label.replace(':labelId', labelId),
  headers: getHeaders(true)
})

export default {
  getHeader,
  deploy,
  setDefault,
  setEarlierVersion,
  getProcessesList,
  getProcessesPartialList,
  process,
  getProcessDetail,
  deleteProcess,
  processPartialUpdate,
  copyProcess,
  getGroupsList,
  addGroup,
  editNameGroup,
  getMessageGroup,
  deleteGroup,
  addMessage,
  deleteMessage,
  messageOrder,
  groupOrder,
  createProcessCategory,
  getProcessCategoriesList,
  updateProcessCategory,
  deleteProcessCategory,
  createLabel,
  getLabelsList,
  updateLabel,
  deleteLabel
}
